import React, { useEffect, useState } from 'react';
// import {  Button, Modal, message, notification, Typography, Popconfirm, Tag, Table, Card, Input } from 'antd';
import { Badge, Breadcrumb, Modal,Button, Card,message, Col, Divider, Grid, notification,Tag,Popconfirm, Popover, Row, Space, Spin, Statistic, Typography,Input ,Table} from 'antd';

import axios from 'axios';

import { useDeleteUserAdminPMutation } from '../../slices/adminApiSlice';
import { useDispatch, useSelector } from 'react-redux';

import { DeleteFilled, EditOutlined, UserAddOutlined, SearchOutlined ,DashboardOutlined,GiftOutlined } from '@ant-design/icons';
import { setSubscriptions } from '../../slices/subscriptionSlice';
import { useDeleteSubAdminPMutation, useGetSubAdminPMutation, useGetSubscriptionMutation } from '../../slices/subscriptionApiSlice';
import moment from 'moment-timezone';
import SubForm from './Form/SubForm';
const { Title, Text } = Typography;

const AdminPackagesScreen = () => {
    const { darkmode } = useSelector((state) => state.darkmode);
  
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const { Text } = Typography;
  const [api, contextHolder] = notification.useNotification();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const { subscription } = useSelector((state) => state.subscription);
  const dispatch = useDispatch();
  
  const [getsubs, { isLoading: isLoading }] = useGetSubAdminPMutation();
  const [deletesub] = useDeleteSubAdminPMutation();

  const getSubs = async () => {
    try {
      const res = await getsubs().unwrap();
      dispatch(setSubscriptions({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  useEffect(() => {
    getSubs();
  }, []);

  const deleteSub = async (subId) => {
    try {
      await deletesub({ subId }).unwrap();
      message.success('Package deleted successfully');
      getSubs();
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  };

  const handleEdit = (user) => {
    setSelectedSub(user);
    setIsModalVisible(true);
  };

  const show = () => {
    setSelectedSub(null);
    setIsModalVisible(true);
  }

  const confirmd = (e, subId) => {
    deleteSub(subId);
  };

  // Columns for the table
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search ID"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button 
          onClick={() => {
            clearFilters();
            confirm(); // trigger confirm to refresh the table after clearing filters
          }}
          size="small" 
          style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, user) => user._id.toLowerCase().includes(value.toLowerCase()),
      width: '30%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, sub) => `${sub.name}`,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button 
          onClick={() => {
            clearFilters();
            confirm(); // trigger confirm to refresh the table after clearing filters
          }}
          size="small" 
          style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, sub) => sub.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (text, sub) => `₹ ${sub.price}`,
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
    },
    {
      title: 'Months',
      dataIndex: 'months',
      key: 'months',

    },
    {
      title: 'Extra Days',
      dataIndex: 'extradays',
      key: 'extradays',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
    },
      // 🆕 Tagline Column
    {
      title: 'Tagline',
      dataIndex: 'tagline',
      key: 'tagline',
      render: (text) => text || <Tag color="default">No tagline</Tag>,
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
    },

    // 🆕 Highlights Column
    {
      title: 'Highlights',
      dataIndex: 'highlights',
      key: 'highlights',
      render: (highlights) =>
        highlights && highlights.length > 0 ? (
          <>
            {highlights.map((h, idx) => (
              <Tag color="blue" key={idx}>
                {h}
              </Tag>
            ))}
          </>
        ) : (
          <Tag color="default">No highlights</Tag>
        ),
    },
    
    {
      title: 'Subscription Status',
      dataIndex: 'subscriptionStatus',
      key: 'subscriptionStatus',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, sub) =>
        sub.active == true ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      onHeaderCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, sub) => `${moment(sub.createdAt).format('ddd, D MMM, YYYY')}`
    },
    {
      title: 'Actions',
      key: 'actions',
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
      render: (text, sub) => (
        <div>
          <Popconfirm
            title="Delete the user"
            description="Are you sure to delete this user?"
            onConfirm={(e) => confirmd(e, sub._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger shape="circle" size='small' icon={<DeleteFilled />} />
          </Popconfirm>
          <Button
            onClick={() => handleEdit(sub)}
            shape="circle"
            size='small'
            icon={<EditOutlined />}
            style={{ marginLeft: 8 }}
          />
        </div>
      ),
    },
  ];

  return (
    <>


       <Title
      style={{
        fontFamily: 'Inter, sans-serif',
        marginBottom: '16px', // Added margin below title
      }}
      level={2}
    >
      <GiftOutlined  /> &nbsp;All Packages
    </Title>

    <Row
      style={{
        padding: "20px",
        backgroundColor: darkmode ? "#141414" : "#FFF",
        borderRadius: "5px",
        marginBottom: "20px", // Added spacing below breadcrumb row
      }}
    >
      <Col flex="auto">
        <Breadcrumb
          items={[{ title: 'packages' }, { title: 'All Packages' }]}
          style={{ marginBottom: "5px" }}
        />
      </Col>
    </Row>
    {contextHolder}
      <Card title="All Packages" extra={<Button type="primary" onClick={show} shape='circle'><UserAddOutlined /></Button>}   style={{ overflowX: 'auto',overflowY:"auto" }}>
        <Table
          columns={columns}
          size='small'
          dataSource={subscription ? subscription : []}
          loading={isLoading}
          rowKey={(sub) => sub._id}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "scroll" }}
          // scroll={{ x: 'max-content' }}

        />
      </Card>
      
      <Modal
        title={selectedSub ? 'Edit Package' : 'Add Package'}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <SubForm sub={selectedSub} getSubs={getSubs} onClose={() => setIsModalVisible(false)} />
      </Modal>
    </>
  );
};

export default AdminPackagesScreen;
